const {
  VITE_PUBLIC_POSTHOG_KEY = undefined,
  VITE_PUBLIC_POSTHOG_HOST = undefined,
  VITE_API_URL = undefined,
} = import.meta.env;

export const enviroment = {
  PUBLIC_POSTHOG_KEY: VITE_PUBLIC_POSTHOG_KEY,
  PUBLIC_POSTHOG_HOST: VITE_PUBLIC_POSTHOG_HOST,
  API_URL: VITE_API_URL,
};
